import {Inject, Injectable, NgZone, Optional} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import { HttpHeaders } from "@angular/common/http";
import {BASE_PATH, Configuration} from "../core/modules/openapi";
import {EventSourcePolyfill, EventSourcePolyfillInit} from 'event-source-polyfill'

/**
 * Server-Sent Events service
 */
@Injectable({
  providedIn: 'root'
})
export class EventSourceService {
  private eventSource: EventSourcePolyfill;
  protected basePath = 'https://localhost:8080/api/insurance/applications/v1';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  /**
   * constructor
   * @param zone - we need to use zone while working with server-sent events
   * because it's an asynchronous operations which are run outside of change detection scope
   * and we need to notify Angular about changes related to SSE events
   */
  constructor(private zone: NgZone, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration: Configuration) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
  }

  /**
   * Method for creation of the EventSource instance
   * @param url - SSE server api path
   * @param options - configuration object for SSE
   */
  getEventSource(url: string, options?: EventSourcePolyfillInit): EventSourcePolyfill {
    return new EventSourcePolyfill(url, options);
  }

  /**
   * Method for establishing connection and subscribing to events from SSE
   * @param options - configuration object for SSE
   * @param eventNames - all event names except error (listens by default) you want to listen to
   */
  connectToServerSentEvents(options?: EventSourcePolyfillInit, eventNames: string[] = []): Observable<any> {
    let localVarPath = `/applications/messages`;
    this.eventSource = this.getEventSource(`${this.configuration.basePath}${localVarPath}`, options);

    return new Observable((subscriber: Subscriber<any>) => {
      this.eventSource.addEventListener('error', event => {
        this.eventSource.close();
        this.zone.run(() => subscriber.error(event));
      });
      this.eventSource.addEventListener('message', event => {
        this.zone.run(() => subscriber.next(event.data));
      });
      this.eventSource.addEventListener('complete', event => {
        this.zone.run(() => subscriber.complete());
      });
    });
  }

  /**
   * Method for closing the connection
   */
  close(): void {
    if (!this.eventSource) {
      return;
    }

    this.eventSource.close();
  }
}
